export const alertSliceName = 'alert';
